import { Controller } from '@hotwired/stimulus'
import { openModalPreventScroll, closeModalRestoreScroll } from '../../utils/modalUtils'
import ChatContext from './chatContext'

// Connects to data-controller="chats--popup"
export default class extends Controller {
  static targets = ['modal']
  static outlets = ['chats--messages', 'utils--expand-details']

  disconnect() {
    this._removeEscapeListener()
  }

  onModalClick(e) {
    if (e.target === this.modalTarget) {
      this.closeChat()
    }
  }

  chatOpen() {
    this.modalTarget.showModal()
    this._addEscapeListener()
    openModalPreventScroll()
    this._resetDialog()
    this._focusInput()
  }

  /**
   * Open chat with specific context
   * Usage: data-action="click->chats--popup#openWithContext"
   *        data-chats--popup-context-param='{"type":"invoice","id":"abc"}'
   */
  openWithContext(event) {
    const context = event.params.context
    if (context) {
      ChatContext.setFocus(context)
    }
    this.chatOpen()
  }

  closeChat() {
    this.modalTarget.close()
    this._removeEscapeListener()
    closeModalRestoreScroll()
  }

  _addEscapeListener() {
    if (!this._boundEscapeListener) {
      this._boundEscapeListener = (e) => {
        if (e.key === 'Escape') {
          this.closeChat()
        }
      }
      document.addEventListener('keydown', this._boundEscapeListener)
    }
  }

  _resetDialog() {
    if (this.hasChatsMessagesOutlet) {
      this.chatsMessagesOutlet.newConversation()
    }
    if (this.hasUtilsExpandDetailsOutlet) {
      this.utilsExpandDetailsOutlet.collapse()
    }
  }

  _focusInput() {
    if (this.hasChatsMessagesOutlet) {
      this.chatsMessagesOutlet.newMessageTarget.focus()
    }
  }

  _removeEscapeListener() {
    if (this._boundEscapeListener) {
      document.removeEventListener('keydown', this._boundEscapeListener)
      this._boundEscapeListener = null
    }
  }
}
